<!-- 视频-分类 -->
<template>
  <div class="wrap2">
    <div class="leftsidebar">
      <ul class="leftsidebar-tab-list">
        <li
            v-for="(item, index) in classList"
            :key="index"
            :class="{ active: classCurrent === item.id }"
            @click="checkClass(index)"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>

    <div class="rightsidebar">
      <ul class="all-list">
        <li v-for="(item, index) in classChildren" :key="index">
          <p class="list-title">{{ item.title }}</p>
          <ul class="sub-list">
            <li v-for="(item2, index2) in classResultMap[`${classCurrent},${item.id}`].list"
                :key="index2"
                @click="$router.push(`/supplier-collection?supplier_id=${item2.id}`)"
            >
              <img :src="item2.cover" class="sub-item-img">
              <div class="sub-item-sidebar">
                <p class="sub-item-name">{{ item2.title }}</p>
                <ul class="tag-list">
                  <li>{{ item2.work_place }}</li>
                </ul>
              </div>
            </li>

            <button
                type="button"
                class="more-btn"
                v-if="
                  classResultMap[`${classCurrent},${item.id}`].list.length > 0
                  &&
                  classResultMap[`${classCurrent},${item.id}`].list.length % commonParams.page_num === 0
                "
                @click="getList([item.id])"
            >
              展开更多
              <img src="../../assets/icon-7.png">
            </button>
          </ul>
        </li>
        <div class="normal-box-small" v-if="classChildren.length === 0">
          <img src="../../assets/normal.png">
          暂无数据
        </div>
      </ul>
    </div>

    <!-- 显示开通vip -->
    <van-overlay :show="showOpenVip" @click="showOpenVip = false" z-index="99999">
      <div class="open-vip">
        <p>仅支持VIP查看</p>
        <p>开通VIP查看本材料</p>
        <button @click="$router.push('/member')">开通VIP会员</button>
      </div>
    </van-overlay>

	</div>
</template>

<script>
import {ArticleService, SupplierService, UserCenterService} from "@/common/service";
import {Dialog} from "vant";

  export default {
		components: {},
		data() {
			return {
        showOpenVip: false,
        commonParams: {
          sort_type: 1,  // 1默认2时间升序3时间降序
          page_num: 5,  // 每页数
        },

        classList: [],
        classCurrent: 0,
        classChildren: [],
        classResultMap: {},
        loading: false,

        isLogin: false,
        isVip: false,
			};
		},
    mounted() {
      this.getCateTree();
      this.getUserInfo();
    },
    methods: {
      getCateTree() {
        this.classResultMap = {};
        return SupplierService.getSupplierCate().then(({ data }) => {
          this.classList = data.list;
          if (data.list.length > 0) {
            this.classCurrent = data.list[0].id;
            this.classChildren = data.list[0].children;
            this.getList(this.classChildren.map(item => item.id));
          }
        });
      },
      getList(ids = []) {
        this.loading = true;
        const req = (id) => {
          const key = `${this.classCurrent},${id}`;
          if (!this.classResultMap[key]) {
            this.$set(this.classResultMap, key, { page: 1, list: [] });
          }
          const params = {
            ...this.commonParams,
            first_classify: this.classCurrent,
            second_classify: id,
            page: this.classResultMap[key].page,
          };
          return SupplierService.getSupplierList(params).then(({ data }) => {
            const list = data.list;
            this.classResultMap[key].list = params.page === 1 ? list : [...this.classResultMap[key].list, ...list];
            if (list.length === params.page_num) {
              this.classResultMap[key].page++;
            }
          });
        };
        if (ids.length > 0) {
          return Promise.all(ids.map(req)).finally(() => this.loading = false);
        } else {
          this.loading = false;
        }
      },
      checkClass(index) {
        if (this.loading) { return; }
        this.classCurrent = this.classList[index].id;
        this.classChildren = this.classList[index].children || [];
        this.classResultMap = {};
        this.getList(this.classChildren.map(item => item.id));
      },
      checkTab(type, isHot) {
        this.commonParams.type = type;
        this.commonParams.is_tj = isHot;
        this.classResultMap = {};
        this.getList(this.classChildren.map(item => item.id));
      },
      checkSortTab(sortType) {
        this.commonParams.sort_type = sortType;
        this.classResultMap = {};
        this.getList(this.classChildren.map(item => item.id));
      },

      getUserInfo() {
        UserCenterService.getUserInfo().then(({ data }) => {
          this.isLogin = true;
          const userLevel = data.user_level;
          if (userLevel && userLevel.id > 0) {
            const currentTime = new Date().getTime();
            const endTime = new Date(userLevel.end_date.replace(/-/g, '/')).getTime();
            this.isVip = currentTime < endTime;
          }
        });
      },

      toDetail(item2) {
        if (item2.item_list.length > 1) {
          this.$router.push(`/image-text-list?id=${item2.id}`);
        } else {
          if (item2.item_list[0].is_vip === 1) {
            if (!this.isLogin) {
              return Dialog.confirm({
                message: 'VIP图文请登录后查看',
                confirmButtonText: '去登录'
              }).then(() => {
                this.$router.push('/login');
              });
            }
            if (!this.isVip) {
              return this.showOpenVip = true;
            }
          }
          this.$router.push(`/image-text-details?id=${item2.id}&item_id=${item2.item_list[0].id}`);
        }
      }

    }
	}
</script>

<style scoped>


.wrap2 {
  width: 100%;
  height: calc(100vh - 84px);
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  background-color: #F4F4F4;
  padding: 0 0 0;
  position: relative;
}

.normal-box-small {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #999992;
  padding: 120px 0;
}

.normal-box-small>img {
  width: 150px;
  margin-bottom: 9px;
}

.leftsidebar {
  width: 80px;
  height: 100%;
  overflow-y: auto;
}

.leftsidebar-tab-list {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.leftsidebar-tab-list>li {
  width: 100%;
  text-align: center;
  height: 56px;
  font-size: 14px;
  color: #222222;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.leftsidebar-tab-list>li.active {
  font-weight: 500;
}

.leftsidebar-tab-list>li.active::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  background: #2A63F3;
  width: 4px;
  height: 18px;
}

.rightsidebar {
  width: calc(100% - 95px);
  height: 100%;
  overflow-y: auto;
}

.all-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
}

.all-list>li {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.list-title {
  width: 100%;
  height: 44px;
  line-height: 44px;
  display: flex;
  align-items: center;
  color: #222222;
  font-size: 14px;
  font-weight: bold;
}

.sub-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 14px 10px;
  box-sizing: border-box;
  background-color: #FFFFFF;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
}

.sub-list>li {
  width: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #F4F4F4;
  box-sizing: border-box;
}


.sub-list>li:last-of-type {
  margin-bottom: 0;
  border-bottom: 1px solid #F4F4F4;
}

.sub-item-img {
  width: 54px;
  height: 54px;
  border-radius: 6px;
  margin-right: 8px;
}

.sub-item-sidebar {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.sub-item-name {
  width: 100%;
  color: #222222;
  font-size: 14px;
  font-weight: bold;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  margin-bottom: 12px;
}

.more-btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2A63F3;
  font-size: 12px;
  padding: 10px 0 0;
}

.more-btn>img {
  width: 8px;
  margin: 0 0 0 4px;
}

.tag-list {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}

.tag-list>li {
  height: 18px;
  line-height: 18px;
  display: flex;
  align-items: center;
  font-size: 10px;
  width: fit-content;
  padding: 0 6px;
  border-radius: 2px;
  margin-right: 10px;
}

.tag-list>li:nth-child(odd) {
  color: #2A63F3;
  background-color: #E7F1FF;
}

.tag-list>li:nth-child(even) {
  color: #4FA753;
  background-color: #E8F6EA;
}

</style>
